<template>
  <el-dialog
    :visible="visible"
    width="720px"
    append-to-body
    :close-on-click-modal="false"
    class="page-dialog center-dialog-no-footer"
    @update:visible="val => emitUpdateVisible(val)"
  >
    <template #title>
      <MemberUidHeader :username="targetInfo.username" :uid="uid" :vip-level="targetInfo.vip_level">
        <span class="dialog-subtitle">{{ dialogTitle }}</span>
      </MemberUidHeader>
    </template>
    <ManageAccountAdjustTab
      ref="adjustRef"
      v-if="active"
      :uid="uid"
      :target-info="targetInfo"
      :member-info="memberInfo"
      :is-active="active"
      :reset-key="resetKey"
      @success="handleSuccess"
    />
  </el-dialog>
</template>

<script>
import { computed, getCurrentInstance, nextTick, ref, watch } from 'vue'
import ManageAccountAdjustTab from '../ManageAccountAdjustTab.vue'
import MemberUidHeader from './MemberUidHeader.vue'

export default {
  name: 'ManualAdjustDialogV2',
  components: { ManageAccountAdjustTab, MemberUidHeader },
  props: {
    visible: { type: Boolean, default: false },
    uid: { type: [Number, String], default: null },
    targetInfo: { type: Object, default: () => ({}) },
    memberInfo: { type: Object, default: () => ({}) },
    mode: { type: String, default: 'up' }, // up|down
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance()
    const resetKey = ref(0)
    const adjustRef = ref(null)
    const active = computed(() => props.visible)
    const emitUpdateVisible = val => emit('update:visible', val)

    const dialogTitle = computed(() => (props.mode === 'down' ? '手动扣除' : '手动加款'))

    const tryPresetMode = async () => {
      // 兼容旧组件 Options API：直接改其内部 form.adjust_method
      await nextTick()
      const inst = adjustRef.value
      if (!inst) return
      if (inst.form && typeof inst.form === 'object') {
        inst.form.adjust_method = props.mode === 'down' ? 'down' : 'up'
      }
    }

    watch(
      () => props.visible,
      async v => {
        if (v) {
          resetKey.value += 1
          await tryPresetMode()
        }
      }
    )

    watch(
      () => props.mode,
      async () => {
        if (props.visible) await tryPresetMode()
      }
    )

    const handleSuccess = () => {
      proxy?.$message?.success('操作成功')
      emit('success')
    }

    return {
      resetKey,
      active,
      adjustRef,
      dialogTitle,
      emitUpdateVisible,
      handleSuccess,
    }
  },
}
</script>

<style lang="scss" scoped>
.dialog-subtitle {
  color: #606266;
  font-weight: 500;
}
</style>
